{
  "contentVersion": "same-mind-20260907.1",
  "themeLabels": {
    "everyday": "일상의 작은 선택",
    "imagination": "가벼운 상상",
    "taste": "먹거리와 취향",
    "rest": "쉬는 리듬",
    "play": "함께 노는 방식",
    "discovery": "새롭게 발견하기",
    "legacy": "이전부터 있던 질문"
  },
  "prompts": [
    {
      "id": "mind-legacy-001",
      "version": 1,
      "theme": "legacy",
      "question": "여행 당일, 더 마음 가는 쪽은?",
      "options": [
        "계획대로",
        "즉흥으로",
        "반반"
      ],
      "provenance": "existing_original_preserved",
      "reviewStatus": "existing_reviewed",
      "legacyIndex": 0
    },
    {
      "id": "mind-legacy-002",
      "version": 1,
      "theme": "legacy",
      "question": "모임이 끝난 뒤라면?",
      "options": [
        "바로 귀가",
        "한 곳 더",
        "가볍게 산책"
      ],
      "provenance": "existing_original_preserved",
      "reviewStatus": "existing_reviewed",
      "legacyIndex": 1
    },
    {
      "id": "mind-legacy-003",
      "version": 1,
      "theme": "legacy",
      "question": "단체 사진은 어느 정도가 좋아요?",
      "options": [
        "많이 찍기",
        "한 장만",
        "안 찍기"
      ],
      "provenance": "existing_original_preserved",
      "reviewStatus": "existing_reviewed",
      "legacyIndex": 2
    },
    {
      "id": "mind-legacy-004",
      "version": 1,
      "theme": "legacy",
      "question": "주말에 충전하는 방식은?",
      "options": [
        "집에서",
        "밖으로",
        "그때 봐서"
      ],
      "provenance": "existing_original_preserved",
      "reviewStatus": "existing_reviewed",
      "legacyIndex": 3
    },
    {
      "id": "mind-legacy-005",
      "version": 1,
      "theme": "legacy",
      "question": "메뉴를 고를 때 더 끌리는 건?",
      "options": [
        "늘 먹던 것",
        "새로운 것",
        "아무거나"
      ],
      "provenance": "existing_original_preserved",
      "reviewStatus": "existing_reviewed",
      "legacyIndex": 4
    },
    {
      "id": "mind-legacy-006",
      "version": 1,
      "theme": "legacy",
      "question": "약속 장소에는 보통 언제 도착해요?",
      "options": [
        "10분 일찍",
        "정각",
        "조금 여유롭게"
      ],
      "provenance": "existing_original_preserved",
      "reviewStatus": "existing_reviewed",
      "legacyIndex": 5
    },
    {
      "id": "mind-everyday-001",
      "version": 1,
      "theme": "everyday",
      "question": "비 오는 날 창가에 앉는다면?",
      "options": [
        "빗소리 듣기",
        "책 펼치기",
        "멍하니 보기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-everyday-002",
      "version": 1,
      "theme": "everyday",
      "question": "버스를 기다릴 때 눈이 가는 건?",
      "options": [
        "지나가는 사람",
        "하늘과 나무",
        "도착 안내판"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-everyday-003",
      "version": 1,
      "theme": "everyday",
      "question": "책상 위에 하나만 놓는다면?",
      "options": [
        "작은 화분",
        "좋아하는 사진",
        "아무것도 없이"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-everyday-004",
      "version": 1,
      "theme": "everyday",
      "question": "새 노트를 펴면 먼저 하는 건?",
      "options": [
        "첫 장부터 쓰기",
        "뒷장에 펜 시험하기",
        "첫 장은 비워 두기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-everyday-005",
      "version": 1,
      "theme": "everyday",
      "question": "설거지를 시작할 때 내 방식은?",
      "options": [
        "작은 것부터",
        "큰 것부터",
        "손에 잡힌 대로"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-everyday-006",
      "version": 1,
      "theme": "everyday",
      "question": "가게에서 아는 노래가 나오면?",
      "options": [
        "노래 제목 떠올리기",
        "속으로 따라 부르기",
        "하던 일 계속하기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-everyday-007",
      "version": 1,
      "theme": "everyday",
      "question": "하루에 여유 10분이 생긴다면?",
      "options": [
        "짧게 걷기",
        "잠깐 눈 감기",
        "좋아하는 것 보기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-everyday-008",
      "version": 1,
      "theme": "everyday",
      "question": "아침 커튼을 열었는데 눈이 왔다면?",
      "options": [
        "바로 구경하기",
        "따뜻한 곳 찾기",
        "이동 길 확인하기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-imagination-001",
      "version": 1,
      "theme": "imagination",
      "question": "구름을 타고 한 바퀴 돈다면?",
      "options": [
        "우리 동네",
        "넓은 바다",
        "밤의 도시"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-imagination-002",
      "version": 1,
      "theme": "imagination",
      "question": "하루만 동물 말을 알아듣는다면?",
      "options": [
        "고양이에게 질문",
        "새의 대화 듣기",
        "개와 산책하기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-imagination-003",
      "version": 1,
      "theme": "imagination",
      "question": "주머니에 작은 문이 생긴다면?",
      "options": [
        "조용한 숲으로",
        "넓은 도서관으로",
        "맛있는 부엌으로"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-imagination-004",
      "version": 1,
      "theme": "imagination",
      "question": "내 방 창문 밖 풍경을 고른다면?",
      "options": [
        "산과 나무",
        "잔잔한 물",
        "반짝이는 거리"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-imagination-005",
      "version": 1,
      "theme": "imagination",
      "question": "로봇 친구가 딱 하나 잘한다면?",
      "options": [
        "정리하기",
        "함께 놀기",
        "이야기 들어주기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-imagination-006",
      "version": 1,
      "theme": "imagination",
      "question": "달에 첫 카페를 연다면 이름은?",
      "options": [
        "달빛 한 모금",
        "무중력 쉼터",
        "오늘도 보름달"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-imagination-007",
      "version": 1,
      "theme": "imagination",
      "question": "매일 작은 축제가 열린다면?",
      "options": [
        "음악 축제",
        "책과 이야기 축제",
        "간식 축제"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-imagination-008",
      "version": 1,
      "theme": "imagination",
      "question": "10분 전으로 돌아갈 수 있다면?",
      "options": [
        "놓친 버스 타기",
        "마지막 한 입 또 먹기",
        "웃긴 장면 다시 보기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-taste-001",
      "version": 1,
      "theme": "taste",
      "question": "따뜻한 빵에서 제일 좋은 순간은?",
      "options": [
        "봉투 열 때 향",
        "첫 한 입",
        "마지막 한 조각"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-taste-002",
      "version": 1,
      "theme": "taste",
      "question": "과일 접시를 함께 고른다면?",
      "options": [
        "달콤한 과일",
        "새콤한 과일",
        "둘 다 섞기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-taste-003",
      "version": 1,
      "theme": "taste",
      "question": "같은 음식을 먹어도 마음 가는 자리는?",
      "options": [
        "창가",
        "조용한 구석",
        "편하게 모이는 자리"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-taste-004",
      "version": 1,
      "theme": "taste",
      "question": "라면 옆에 하나 더한다면?",
      "options": [
        "계란 하나",
        "김치 한 접시",
        "밥 한 숟가락"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-taste-005",
      "version": 1,
      "theme": "taste",
      "question": "도시락 뚜껑을 열었을 때 반가운 건?",
      "options": [
        "익숙한 반찬",
        "처음 보는 반찬",
        "예쁘게 담긴 모습"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-taste-006",
      "version": 1,
      "theme": "taste",
      "question": "새로운 간식이 눈에 띄면?",
      "options": [
        "작은 것부터 맛보기",
        "설명부터 읽기",
        "익숙한 것으로 고르기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-taste-007",
      "version": 1,
      "theme": "taste",
      "question": "여름에 시원한 한 입을 고른다면?",
      "options": [
        "얼린 과일",
        "차가운 면",
        "아이스크림"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-taste-008",
      "version": 1,
      "theme": "taste",
      "question": "같이 만들기 좋은 메뉴는?",
      "options": [
        "토핑 얹는 피자",
        "돌돌 마는 김밥",
        "모양 내는 쿠키"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-rest-001",
      "version": 1,
      "theme": "rest",
      "question": "주말 아침에 알람이 없다면?",
      "options": [
        "평소처럼 일어나기",
        "조금 더 자기",
        "그날 몸에 맡기기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-rest-002",
      "version": 1,
      "theme": "rest",
      "question": "잠깐 쉬는 동안 듣고 싶은 소리는?",
      "options": [
        "자연 소리",
        "잔잔한 음악",
        "조용한 무음"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-rest-003",
      "version": 1,
      "theme": "rest",
      "question": "산책길에 갈림길이 나오면?",
      "options": [
        "익숙한 길",
        "처음 가는 길",
        "그늘 많은 길"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-rest-004",
      "version": 1,
      "theme": "rest",
      "question": "긴 일을 끝낸 뒤 먼저 하고 싶은 건?",
      "options": [
        "자리 정리",
        "몸 펴기",
        "아무것도 안 하기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-rest-005",
      "version": 1,
      "theme": "rest",
      "question": "책을 읽다가 졸리면?",
      "options": [
        "책갈피 끼우기",
        "한 쪽만 더 읽기",
        "편한 자리로 옮기기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-rest-006",
      "version": 1,
      "theme": "rest",
      "question": "쉬는 시간, 조명을 고른다면?",
      "options": [
        "커튼 열고 햇빛",
        "책상 위 작은 등",
        "불 끄고 어둡게"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-rest-007",
      "version": 1,
      "theme": "rest",
      "question": "기다리는 시간이 넉넉하다면?",
      "options": [
        "주변 구경",
        "앉아서 쉬기",
        "작은 할 일 끝내기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-rest-008",
      "version": 1,
      "theme": "rest",
      "question": "하루의 마침표를 찍는다면?",
      "options": [
        "내일 준비",
        "오늘 한 줄 적기",
        "편안히 눕기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-play-001",
      "version": 1,
      "theme": "play",
      "question": "새 게임을 배울 때 편한 방법은?",
      "options": [
        "직접 해보기",
        "시범 한 번 보기",
        "짧은 규칙 읽기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-play-002",
      "version": 1,
      "theme": "play",
      "question": "모두 힘을 합치는 게임이라면?",
      "options": [
        "기억 맞추기",
        "박자 맞추기",
        "수수께끼 풀기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-play-003",
      "version": 1,
      "theme": "play",
      "question": "팀 이름을 정하는 방식은?",
      "options": [
        "눈에 보이는 물건",
        "엉뚱한 단어 조합",
        "다 같이 한 글자씩"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-play-004",
      "version": 1,
      "theme": "play",
      "question": "게임에서 웃음이 나는 순간은?",
      "options": [
        "뜻밖의 역전",
        "아슬아슬한 성공",
        "우연히 답이 일치"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-play-005",
      "version": 1,
      "theme": "play",
      "question": "첫 순서를 정한다면?",
      "options": [
        "먼저 원하는 사람",
        "가위바위보",
        "제비뽑기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-play-006",
      "version": 1,
      "theme": "play",
      "question": "함께 퍼즐을 맞출 때 맡고 싶은 건?",
      "options": [
        "테두리 찾기",
        "비슷한 색 모으기",
        "필요한 조각 찾기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-play-007",
      "version": 1,
      "theme": "play",
      "question": "모두 같은 답을 골랐다면?",
      "options": [
        "짧게 환호",
        "서로 눈 마주치기",
        "바로 다음 질문"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-play-008",
      "version": 1,
      "theme": "play",
      "question": "다음 판의 속도는 어느 쪽?",
      "options": [
        "조금 더 빠르게",
        "지금처럼",
        "천천히 여유 있게"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-discovery-001",
      "version": 1,
      "theme": "discovery",
      "question": "처음 온 동네에서 먼저 눈에 담는 건?",
      "options": [
        "가게 간판",
        "건물 모양",
        "나무와 골목"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-discovery-002",
      "version": 1,
      "theme": "discovery",
      "question": "박물관에서 더 오래 머무는 곳은?",
      "options": [
        "작은 생활 물건 앞",
        "커다란 작품 앞",
        "직접 해보는 체험"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-discovery-003",
      "version": 1,
      "theme": "discovery",
      "question": "선물 포장에 하나 더한다면?",
      "options": [
        "짧은 손글씨",
        "작은 그림",
        "깔끔한 리본"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-discovery-004",
      "version": 1,
      "theme": "discovery",
      "question": "지도를 펼치면 먼저 찾는 것은?",
      "options": [
        "지금 있는 곳",
        "가보고 싶은 곳",
        "길의 모양"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-discovery-005",
      "version": 1,
      "theme": "discovery",
      "question": "색연필 세트에서 먼저 고를 색은?",
      "options": [
        "따뜻한 색",
        "차가운 색",
        "그날 눈에 띄는 색"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-discovery-006",
      "version": 1,
      "theme": "discovery",
      "question": "사진 대신 오늘을 남긴다면?",
      "options": [
        "한 문장",
        "작은 그림",
        "기억할 소리 하나"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-discovery-007",
      "version": 1,
      "theme": "discovery",
      "question": "새 취미를 하루 체험한다면?",
      "options": [
        "손으로 만들기",
        "천천히 움직이기",
        "무언가 관찰하기"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    },
    {
      "id": "mind-discovery-008",
      "version": 1,
      "theme": "discovery",
      "question": "다 같이 짧은 이야기를 만든다면?",
      "options": [
        "장소부터 정하기",
        "주인공부터 정하기",
        "마지막 장면부터"
      ],
      "provenance": "original_authored",
      "reviewStatus": "independent_editorial_reviewed"
    }
  ]
}
